import { FC } from "react";

export const NPMQesViewBadge: FC = () => (
  <span className="npm-qes-sv-badge npm-qes-sv-badge--qes" data-testid="npm-sv-qes-badge">QES View</span>
);
